import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";
import UnreadMessageGroupList from "./unread_message_group_list";
import CircleMessageGroupList from "./circle_message_group_list";
import EventMessageGroupList from "./event_message_group_list";
import MessageGroupList from "./message_group_list";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    messageGroupId: PropTypes.number,
    circleId: PropTypes.number,
    eventId: PropTypes.number,
    isCompany: PropTypes.bool,
  },
  render() {
    // var currentUser = this.props.currentUser;
    return (
      <div className="message-left">
        <div className="block-listWrap-type1 block-self smp-none">
          <div className="block-member is-type-no-border">
            <div className="txt-member">
              <a href="/">
                <span className="txt-name color-white">ホームへ戻る</span>
              </a>
            </div>
          </div>
        </div>

        <div
          className="block-memberList smp-none"
          style={{ paddingTop: "60px" }}
        >
          <UnreadMessageGroupList />
          <div className="block-listWrap-type1">
            <h2 className="ttl-type1">所属サークルのメッセージ</h2>&nbsp;&nbsp;
            <CircleMessageGroupList
              circleId={this.props.circleId ? this.props.circleId : 0}
              isCompany={this.props.isCompany}
            />
          </div>
          <div className="block-listWrap-type1">
            <h2 className="ttl-type1">参加イベントのメッセージ</h2>&nbsp;&nbsp;
            <EventMessageGroupList
              eventId={this.props.eventId ? this.props.eventId : 0}
              isCompany={this.props.isCompany}
            />
          </div>
          <div className="block-listWrap-type1">
            <h2 className="ttl-type1">個人間メッセージ</h2>&nbsp;&nbsp;
            {/* <a href="" data-toggle="modal" data-target="#join-direct-message" style={{display:'inline-block'}}><span className="glyphicon glyphicon-plus-sign" aria-hidden="true"></span> 追加</a> */}
            <MessageGroupList
              messageGroupId={
                this.props.messageGroupId ? this.props.messageGroupId : 0
              }
              isCompany={this.props.isCompany}
            />
          </div>
        </div>
      </div>
    );
  },
});
